import React from 'react'

import { IProps } from './IProps'
import { BlobCore, BlobThree, BlobTwo } from './style'

export const Blobs = ({ blobColor, blobNumber, gradient, blur }: IProps) => {
  return (
    <>
      {blobNumber >= 1 ? (
        <BlobCore color={blobColor} gradient={gradient} blurEffect={blur} />
      ) : (
        <BlobCore />
      )}
      {blobNumber >= 2 ? (
        <BlobTwo color={blobColor} gradient={gradient} blurEffect={blur} />
      ) : null}
      {blobNumber >= 3 ? (
        <BlobThree color={blobColor} gradient={gradient} blurEffect={blur} />
      ) : null}
    </>
  )
}
